import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  user: null,
  token: null,
  refreshToken: null,
}

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    login: (state, action) => {
      state.user = action.payload.user
      state.token = action.payload.token
      state.refreshToken = action.payload.refresh_token
    },

    logout: (state) => {
      state.user = null
      state.token = null
      state.refreshToken = null
    },
  },
})

export const { login, logout } = authSlice.actions

export const selectUser = (state) => state.auth.user
export const selectToken = (state) => state.auth.token
export const selectRefreshToken = (state) => state.auth.refreshToken

export default authSlice.reducer
